import type { ButtonConfig } from '../../declare'
import { useState, useEffect, useMemo, useContext } from 'react'
import { autorun } from 'mobx'
import { Button } from 'antd'
import { EasyModal, EasyIcon, EditPage } from 'src/components'
import { ListPropsContext } from 'src/components'
import { listStore } from 'src/stores'

type Props = {
  config: ButtonConfig
}

const EditModalBtn = (props: Props) => {
  const table = listStore.table.get(useContext(ListPropsContext).formCode)

  const [disabled, setDisabled] = useState(false)
  useEffect(() => autorun(() => {
    setDisabled(!table?.selectedData?.length)
  }), [])

  const formData = useMemo(() => {
    return { batchEdit: true }
  }, [])

  const { LABEL, ICON, FORM_CODE, WIDTH } = props.config
  return (
    <EasyModal
      modal={{ title: FORM_CODE, width: WIDTH }}
      slot={<Button disabled={disabled} icon={<EasyIcon type={ICON} defaultIcon='EditOutlined' />}>{LABEL}</Button>}
    >
      <EditPage formCode={FORM_CODE} formData={formData} />
    </EasyModal>
  )
}

export default EditModalBtn